import { Heading } from "@components/ui/typograhpy/Heading"
import { Text } from "@components/ui/typograhpy/Text"
import React, { FC } from "react"
import { RequestPasswordResetFormForm as Form } from "./Form"

export const RequestPasswordResetForm: FC = () => {
  return (
    <div className="flex flex-wrap justify-center md:justify-start w-full">
      <Heading className="mb-8" variant="h2">
        Need help?
      </Heading>
      <Text className="mb-5" variant="regular">
        Forgot your password? Fill in your email address and we’ll help you
        recover your account.
      </Text>
      <Form />
    </div>
  )
}
